import { createContext } from 'react'
import { noop } from '../../utils/function'

interface MenuContextType { closeMenu: () => void }

export const MenuContext = createContext<MenuContextType>({ closeMenu: noop })
